import { useSyncExternalStore } from 'react';

function subscribeToResize(onChange: () => void) {
  window.addEventListener('resize', onChange);
  return () => {
    window.removeEventListener('resize', onChange);
  };
}

function subscribeToNothing() {
  return () => undefined;
}

function readViewportWidth() {
  return window.innerWidth;
}

export function useViewportWidth(tracking = true): number {
  return useSyncExternalStore(tracking ? subscribeToResize : subscribeToNothing, readViewportWidth);
}
